/* ===== Card Component ===== */

import type { HTMLAttributes, ReactNode } from 'react'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  hoverable?: boolean
  bordered?: boolean
}

export function Card({
  children,
  hoverable = false,
  bordered = true,
  className = '',
  ...props
}: CardProps) {
  return (
    <div
      className={`
        bg-white dark:bg-neutral-900 rounded-[18px] p-5 shadow-card-elevated transition-all duration-200
        ${bordered ? 'border border-neutral-200 dark:border-neutral-800' : ''}
        ${hoverable ? 'hover:-translate-y-0.5 hover:border-primary-200 dark:hover:border-primary-500/30' : ''}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  )
}

export function CardHeader({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`flex items-center justify-between gap-4 border-b border-neutral-100 pb-4 mb-4 dark:border-neutral-800 ${className}`}>{children}</div>
}

export function CardTitle({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <h3 className={`text-base font-bold text-neutral-900 dark:text-neutral-100 ${className}`}>{children}</h3>
}

export function CardDescription({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <p className={`mt-1 text-sm text-neutral-500 dark:text-neutral-400 ${className}`}>{children}</p>
}

export function CardContent({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={className}>{children}</div>
}

export function CardFooter({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`mt-4 flex items-center justify-end gap-3 border-t border-neutral-100 pt-4 dark:border-neutral-800 ${className}`}>{children}</div>
}
